import ApolloClient from 'apollo-client';
import { ApolloLink, Observable, from, fromError, split } from 'apollo-link';
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import { SubscriptionClient } from '@deal/subscriptions-transport-ws';
import { checkFetcher, createSignalIfSupported, fallbackHttpConfig, parseAndCheckHttpResponse, selectHttpOptionsAndBody, selectURI, serializeFetchParameter } from 'apollo-link-http-common';
import { BatchLink } from 'apollo-link-batch';
import extractFiles from 'extract-files';
import { HttpLink } from 'apollo-link-http';
import { getMainDefinition } from 'apollo-utilities';
import cookies from 'js-cookie';
import fetch$1 from 'cross-fetch';
import getRandomValuesPolyfill from 'polyfill-crypto.getrandomvalues';
import { B3Format } from '@opencensus/propagation-b3';
import Cookie from 'cookie';
import setCookie from 'set-cookie-parser';
import { onError } from 'apollo-link-error';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

var WebSocketLink = (function (_super) {
    __extends(WebSocketLink, _super);
    function WebSocketLink(paramsOrClient) {
        var _this = _super.call(this) || this;
        if (paramsOrClient instanceof SubscriptionClient) {
            _this.subscriptionClient = paramsOrClient;
        }
        else {
            _this.subscriptionClient = new SubscriptionClient(paramsOrClient.uri, paramsOrClient.options, paramsOrClient.webSocketImpl);
        }
        return _this;
    }
    WebSocketLink.prototype.request = function (operation) {
        return this.subscriptionClient.request(operation);
    };
    return WebSocketLink;
}(ApolloLink));

var BatchUploadLink = (function (_super) {
    __extends(BatchUploadLink, _super);
    function BatchUploadLink(fetchParams) {
        if (fetchParams === void 0) { fetchParams = {}; }
        var _this = _super.call(this) || this;
        var _a = fetchParams.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = fetchParams.fetch, includeExtensions = fetchParams.includeExtensions, batchInterval = fetchParams.batchInterval, batchMax = fetchParams.batchMax, batchKey = fetchParams.batchKey, requestOptions = __rest(fetchParams, ["uri", "fetch", "includeExtensions", "batchInterval", "batchMax", "batchKey"]);
        checkFetcher(fetcher);
        if (!fetcher) {
            fetcher = fetch;
        }
        var linkConfig = {
            http: { includeExtensions: includeExtensions },
            options: requestOptions.fetchOptions,
            credentials: requestOptions.credentials,
            headers: requestOptions.headers
        };
        _this.batchInterval = batchInterval || 10;
        _this.batchMax = batchMax || 10;
        var batchHandler = function (operations) {
            var chosenURI = selectURI(operations[0], uri);
            var context = operations[0].getContext();
            var contextConfig = {
                http: context.http,
                options: context.fetchOptions,
                credentials: context.credentials,
                headers: context.headers
            };
            var optsAndBody = operations.map(function (operation) {
                return selectHttpOptionsAndBody(operation, fallbackHttpConfig, linkConfig, contextConfig);
            });
            var body = optsAndBody.map(function (_a) {
                var body = _a.body;
                return body;
            });
            var options = optsAndBody[0].options;
            if (options.method === 'GET') {
                return fromError(new Error('apollo-link-batch-http does not support GET requests'));
            }
            var files = extractFiles(body);
            if (files.length) {
                delete options.headers['content-type'];
                options.body = new FormData();
                options.body.append('operations', serializeFetchParameter(body, 'Payload'));
                options.body.append('map', JSON.stringify(files.reduce(function (map, _a, index) {
                    var path = _a.path;
                    map["" + index] = [path];
                    return map;
                }, {})));
                files.forEach(function (_a, index) {
                    var file = _a.file;
                    return options.body.append(index, file, file.name);
                });
            }
            else {
                try {
                    
                    options.body = serializeFetchParameter(body, 'Payload');
                }
                catch (parseError) {
                    return fromError(parseError);
                }
            }
            var _a = createSignalIfSupported(), controller = _a.controller, signal = _a.signal;
            if (controller)
                options.signal = signal;
            return new Observable(function (observer) {
                fetcher(chosenURI, options)
                    .then(function (response) {
                    operations.forEach(function (operation) { return operation.setContext({ response: response }); });
                    return response;
                })
                    .then(parseAndCheckHttpResponse(operations))
                    .then(function (result) {
                    observer.next(result);
                    observer.complete();
                    return result;
                })
                    .catch(function (err) {
                    if (err.name === 'AbortError')
                        return;
                    if (err.result && err.result.errors && err.result.data) {
                        observer.next(err.result);
                    }
                    observer.error(err);
                });
                return function () {
                    if (controller)
                        controller.abort();
                };
            });
        };
        batchKey =
            batchKey ||
                (function (operation) {
                    var context = operation.getContext();
                    var contextConfig = {
                        http: context.http,
                        options: context.fetchOptions,
                        credentials: context.credentials,
                        headers: context.headers
                    };
                    return selectURI(operation, uri) + JSON.stringify(contextConfig);
                });
        _this.batcher = new BatchLink({
            batchInterval: _this.batchInterval,
            batchMax: _this.batchMax,
            batchKey: batchKey,
            batchHandler: batchHandler
        });
        return _this;
    }
    BatchUploadLink.prototype.request = function (operation) {
        return this.batcher.request(operation);
    };
    return BatchUploadLink;
}(ApolloLink));

function isSubscription(op) {
    var definition = getMainDefinition(op.query);
    return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
}
function createHttpLink(options) {
    var httpLink;
    if (options.batchingEnabled) {
        httpLink = new BatchUploadLink({
            uri: options.endpoint,
            credentials: 'include',
            fetch: options.fetch
        });
    }
    else {
        httpLink = new HttpLink({
            uri: options.endpoint,
            credentials: 'include',
            fetch: options.fetch
        });
    }
    var link;
    if (options.webSocketEndpoint) {
        var webSocketLink = new WebSocketLink({
            uri: options.webSocketEndpoint,
            options: {
                reconnect: true,
                lazy: true,
                connectionParams: function () {
                    return {
                        xsrfToken: cookies.get('XSRF-TOKEN'),
                        viewerContext: options.viewerContext ? options.viewerContext() : undefined,
                        experimentOverrides: options.experimentOverrides
                    };
                }
            }
        });
        var subscriptionClient_1 = webSocketLink.subscriptionClient;
        link = {
            link: split(isSubscription, webSocketLink, httpLink),
            reconnect: function () {
                subscriptionClient_1.close(false);
            }
        };
    }
    else {
        var rejectLink = new ApolloLink(function () { return null; });
        link = {
            link: split(isSubscription, rejectLink, httpLink),
            reconnect: function () { }
        };
    }
    return link;
}

var HeaderName = 'X-Deal-New-Auth-Sent';
function reconnectAuthChange(reconnect) {
    return new ApolloLink(function (operation, forward) {
        var observable = forward(operation);
        if (!observable.map) {
            return observable;
        }
        return observable.map(function (executionResult) {
            var response = operation.getContext().response;
            if (response && response.headers && response.headers.get(HeaderName) === 'true') {
                reconnect();
            }
            return executionResult;
        });
    });
}

function dealApiClient(clientOptions) {
    var ssrMode = clientOptions.ssrMode;
    var _a = createHttpLink({
        endpoint: clientOptions.endpoint,
        webSocketEndpoint: !ssrMode ? clientOptions.webSocketEndpoint : undefined,
        viewerContext: clientOptions.viewerContext,
        experimentOverrides: clientOptions.experimentOverrides,
        batchingEnabled: !ssrMode,
        fetch: fetch$1
    }), httpLink = _a.link, reconnect = _a.reconnect;
    var cache = new InMemoryCache({
        fragmentMatcher: new IntrospectionFragmentMatcher({
            introspectionQueryResultData: clientOptions.introspectionQueryResultData
        })
    }).restore(clientOptions.initialCacheState || {});
    var apolloClient = new ApolloClient({
        link: from((clientOptions.links || []).concat([reconnectAuthChange(reconnect), httpLink])),
        cache: cache,
        connectToDevTools: !ssrMode,
        ssrMode: ssrMode
    });
    return {
        apolloClient: apolloClient,
        reconnect: reconnect,
        cache: cache
    };
}

var getRandomValues = getRandomValuesPolyfill;
if (process.env.TARGET === 'node') {
    getRandomValues = function (arr) {
        var randomBytes = require('crypto').randomBytes;
        return arr.map(function () {
            return parseInt(randomBytes(arr.BYTES_PER_ELEMENT || 4).toString('hex'), 16);
        });
    };
}
var getRandomValues$1 = (global.crypto && global.crypto.getRandomValues
    ? global.crypto.getRandomValues.bind(global.crypto)
    :
        global.msCrypto && global.msCrypto.getRandomValues
            ? global.msCrypto.getRandomValues.bind(global.msCrypto)
            :
                getRandomValues);

function addRequestHeaders(headersToAdd) {
    return new ApolloLink(function (operation, forward) {
        var headers = typeof headersToAdd === 'function' ? headersToAdd(operation) : headersToAdd;
        if (Object.keys(headers).length > 0) {
            operation.setContext({
                headers: __assign(__assign({}, operation.getContext().headers), headers)
            });
        }
        return forward(operation);
    });
}

function addClientInstanceIdHeader() {
    var clientId = getRandomValues$1(Uint32Array ? new Uint32Array(4) : new Array(4)).join('-');
    return addRequestHeaders({ 'X-Deal-Client-Instance-ID': clientId });
}

var b3Format = new B3Format();
function tracePropagation(spanContext) {
    var b3HeaderValues = {};
    if (spanContext) {
        b3Format.inject({
            setHeader: function (key, value) { return (b3HeaderValues[key] = value); }
        }, spanContext);
    }
    return addRequestHeaders(function () { return b3HeaderValues; });
}

function addForwardedFor(forwardedFor) {
    return addRequestHeaders(function () {
        if (forwardedFor) {
            return { 'X-Forwarded-For': forwardedFor };
        }
        else {
            return {};
        }
    });
}

function xsrfCookieToHeader() {
    return addRequestHeaders(function () {
        return { 'X-XSRF-BYPASS': 1 };
    });
}

function proxyCookieHeader(rawCookiesFromClient, cookiesFromServer) {
    var parsedCookiesFromClient = rawCookiesFromClient ? Cookie.parse(rawCookiesFromClient) : {};
    delete parsedCookiesFromClient['XSRF-TOKEN'];
    var cookiesFromClient = {};
    Object.getOwnPropertyNames(parsedCookiesFromClient).forEach(function (key) {
        cookiesFromClient[key] = Cookie.serialize(key, parsedCookiesFromClient[key]);
    });
    return addRequestHeaders(function () {
        var mergedCookies = __assign({}, cookiesFromClient);
        Object.getOwnPropertyNames(cookiesFromServer).forEach(function (key) {
            var parsedCookieValue = Cookie.parse(cookiesFromServer[key]);
            if (parsedCookieValue['Max-Age'] === '0') {
                delete mergedCookies[key];
            }
            else {
                mergedCookies[key] = Cookie.serialize(key, parsedCookieValue[key]);
            }
        });
        var headerValue = Object.getOwnPropertyNames(mergedCookies)
            .map(function (key) { return mergedCookies[key]; })
            .join('; ');
        return headerValue ? { Cookie: headerValue } : {};
    });
}

function collectCookie(cookieJar, value) {
    setCookie.parse(value).forEach(function (parsed) {
        if (parsed.name && parsed.name !== 'XSRF-TOKEN') {
            cookieJar[parsed.name] = Cookie.serialize(parsed.name, parsed.value, parsed);
        }
    });
}
function collectFromOperation(cookieJar, operation) {
    var response = operation.getContext().response;
    if (!response) {
        return;
    }
    var headers = response.headers;
    if (headers.raw) {
        var raw_1 = headers.raw();
        Object.keys(raw_1).forEach(function (name) {
            if (name.toLowerCase() === 'set-cookie') {
                raw_1[name].forEach(function (value) { return collectCookie(cookieJar, value); });
            }
        });
    }
    else {
        response.headers.forEach(function (value, name) {
            if (name.toLowerCase() === 'set-cookie') {
                collectCookie(cookieJar, value);
            }
        });
    }
}
function collectSuccessLink(cookieJar) {
    return new ApolloLink(function (operation, forward) {
        return forward(operation).map(function (executionResult) {
            collectFromOperation(cookieJar, operation);
            return executionResult;
        });
    });
}
function collectErrorLink(cookieJar) {
    return onError(function (error) {
        console.error('Error encountered from the GraphQL API. Collecting "Set-Cookie" headers and propagating them back to the browser client.', error, error.operation.getContext().response);
        collectFromOperation(cookieJar, error.operation);
    });
}
function collectCookies(cookieJar) {
    return ApolloLink.from([collectSuccessLink(cookieJar), collectErrorLink(cookieJar)]);
}

var passthroughLink = new ApolloLink(function (operation, forward) { return forward(operation); });
function passthrough() {
    return passthroughLink;
}

function addExperimentOverridesHeader(experimentOverrides) {
    if (experimentOverrides) {
        return addRequestHeaders({ 'X-Deal-Experiment-Overrides': experimentOverrides });
    }
    else {
        return passthrough();
    }
}

function addForceTraceHeader(forceTrace) {
    return addRequestHeaders(function () {
        var forceTraceValue = forceTrace && forceTrace();
        if (forceTraceValue) {
            return { 'X-Deal-Force-Trace': forceTraceValue };
        }
        else {
            return {};
        }
    });
}

function addIsBotHeader(getIsBot) {
    return addRequestHeaders(function () {
        var isBot = getIsBot && getIsBot();
        if (isBot) {
            return { 'X-Deal-Is-Bot': '1' };
        }
        else {
            return {};
        }
    });
}

var DealViewerContext;
(function (DealViewerContext) {
    DealViewerContext["CONSUMER"] = "CONSUMER";
    DealViewerContext["OPERATIONS"] = "OPERATIONS";
    DealViewerContext["BUSINESS"] = "BUSINESS";
})(DealViewerContext || (DealViewerContext = {}));
function viewerContextLink(viewerContext) {
    return addRequestHeaders(function () {
        if (viewerContext) {
            return { 'X-Deal-Viewer-Context': viewerContext() };
        }
        else {
            return {};
        }
    });
}

function loginTokenHeader(loginToken) {
    return addRequestHeaders(function () {
        if (loginToken) {
            return { 'X-Deal-Login-Token': loginToken };
        }
        else {
            return {};
        }
    });
}

function loginTokenHeader$1(requestOrigin) {
    return addRequestHeaders({ Origin: requestOrigin });
}

function userAgent(userAgent) {
    if (!userAgent) {
        return passthrough();
    }
    else {
        return addRequestHeaders(function () { return ({
            'user-agent': userAgent
        }); });
    }
}

function errorLink(_a) {
    var handleError = _a.onError, handleNetworkError = _a.onNetworkError, handleGraphQLError = _a.onGraphQLError;
    return onError(function (error) {
        if (handleError) {
            handleError(error);
        }
        if (error.networkError && handleNetworkError) {
            handleNetworkError(error.networkError);
        }
        if (error.graphQLErrors && handleGraphQLError) {
            handleGraphQLError(error.graphQLErrors);
        }
    });
}

function serverDealApiClient(_a) {
    var protocol = _a.protocol, host = _a.host, port = _a.port, spanContext = _a.spanContext, clientCookieHeader = _a.clientCookieHeader, cookiesFromServer = _a.cookiesFromServer, forwardedFor = _a.forwardedFor, introspectionQueryResultData = _a.introspectionQueryResultData, experimentOverrides = _a.experimentOverrides, viewerContext = _a.viewerContext, loginToken = _a.loginToken, requestOrigin = _a.requestOrigin, onError$$1 = _a.onError, onNetworkError = _a.onNetworkError, onGraphQLError = _a.onGraphQLError, links = _a.links, forceTrace = _a.forceTrace, isBot = _a.isBot, userAgent$$1 = _a.userAgent;
    return dealApiClient({
        endpoint: protocol + "://" + host + ":" + port + "/graphql",
        links: (links || []).concat([
            addClientInstanceIdHeader(),
            tracePropagation(spanContext),
            addForwardedFor(forwardedFor),
            xsrfCookieToHeader(),
            addExperimentOverridesHeader(experimentOverrides),
            addForceTraceHeader(forceTrace),
            addIsBotHeader(isBot),
            viewerContextLink(viewerContext),
            loginTokenHeader(loginToken),
            loginTokenHeader$1(requestOrigin),
            userAgent(userAgent$$1),
            errorLink({ onError: onError$$1, onNetworkError: onNetworkError, onGraphQLError: onGraphQLError }),
            proxyCookieHeader(clientCookieHeader, cookiesFromServer),
            collectCookies(cookiesFromServer)
        ]),
        ssrMode: true,
        introspectionQueryResultData: introspectionQueryResultData,
        viewerContext: viewerContext,
        experimentOverrides: experimentOverrides
    });
}

function xsrfCookieToHeader$1() {
    return addRequestHeaders(function () {
        var csrfToken = cookies.get('XSRF-TOKEN');
        if (csrfToken) {
            return { 'X-XSRF-TOKEN': csrfToken };
        }
        else {
            return {};
        }
    });
}

function getDomainName(hostname) {
    return hostname
        .split('.')
        .slice(-2)
        .join('.')
        .toLowerCase();
}
function browserDealApiClient(_a) {
    var protocol = _a.protocol, host = _a.host, port = _a.port, introspectionQueryResultData = _a.introspectionQueryResultData, initialCacheState = _a.initialCacheState, experimentOverrides = _a.experimentOverrides, viewerContext = _a.viewerContext, onError$$1 = _a.onError, onGraphQLError = _a.onGraphQLError, onNetworkError = _a.onNetworkError, webSocketProtocol = _a.webSocketProtocol, links = _a.links, forceTrace = _a.forceTrace, isBot = _a.isBot;
    if (getDomainName(host) !== getDomainName(window.location.hostname)) {
        console.warn("The client hostname (" + window.location.hostname + ") does not appear to match the API hostname (" + host + "). The API server may reject CORS requests!");
    }
    return dealApiClient({
        endpoint: protocol + "://" + host + ":" + port + "/graphql",
        webSocketEndpoint: webSocketProtocol
            ? webSocketProtocol + "://" + host + ":" + port + "/ws/graphql"
            : undefined,
        links: (links || []).concat([
            addClientInstanceIdHeader(),
            xsrfCookieToHeader$1(),
            addExperimentOverridesHeader(experimentOverrides),
            addIsBotHeader(isBot),
            addForceTraceHeader(forceTrace),
            viewerContextLink(viewerContext),
            errorLink({ onError: onError$$1, onNetworkError: onNetworkError, onGraphQLError: onGraphQLError })
        ]),
        introspectionQueryResultData: introspectionQueryResultData,
        initialCacheState: initialCacheState,
        viewerContext: viewerContext,
        experimentOverrides: experimentOverrides
    });
}

function authHeadersLink(fetchTokens) {
    if (!fetchTokens) {
        return passthrough();
    }
    else {
        return addRequestHeaders(function () {
            var headers = {};
            var _a = fetchTokens(), sn = _a.sn, at = _a.at;
            if (sn) {
                headers['X-Deal-Sn'] = sn;
            }
            if (at) {
                headers['Authorization'] = "Bearer " + at;
            }
            return headers;
        });
    }
}

function reactNativeDealApiClient(_a) {
    var protocol = _a.protocol, host = _a.host, port = _a.port, introspectionQueryResultData = _a.introspectionQueryResultData, experimentOverrides = _a.experimentOverrides, viewerContext = _a.viewerContext, onError$$1 = _a.onError, onNetworkError = _a.onNetworkError, onGraphQLError = _a.onGraphQLError, webSocketProtocol = _a.webSocketProtocol, links = _a.links, fetchTokens = _a.fetchTokens, forceTrace = _a.forceTrace;
    return dealApiClient({
        endpoint: protocol + "://" + host + ":" + port + "/graphql",
        webSocketEndpoint: webSocketProtocol
            ? webSocketProtocol + "://" + host + ":" + port + "/ws/graphql"
            : undefined,
        links: (links || []).concat([
            authHeadersLink(fetchTokens),
            addClientInstanceIdHeader(),
            xsrfCookieToHeader$1(),
            addExperimentOverridesHeader(experimentOverrides),
            addForceTraceHeader(forceTrace),
            viewerContextLink(viewerContext),
            errorLink({ onError: onError$$1, onNetworkError: onNetworkError, onGraphQLError: onGraphQLError })
        ]),
        introspectionQueryResultData: introspectionQueryResultData,
        viewerContext: viewerContext,
        experimentOverrides: experimentOverrides
    });
}

export { serverDealApiClient, browserDealApiClient, reactNativeDealApiClient, DealViewerContext, addRequestHeaders as addRequestHeadersLink };
//# sourceMappingURL=index.esm.js.map
